import { GetStaticPaths, GetStaticProps } from 'next'

import initApollo, { API } from '../../api'

import { PAGES, POSTS, TOPIC } from './queries'

export const getTopicPaths = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.TopicPages>({
    query: PAGES,
  })

  const topics = data.libraryTopics

  return ['/topics/all', ...topics.map((topic) => `/topics/${topic.slug}`)]
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = await getTopicPaths()

  return { paths, fallback: false }
}

export type Props = API.Topic['libraryTopic'] & {
  posts: NonNullable<API.TopicPosts['libraryPosts']>['nodes']
  filters: {
    type: API.LibraryPostType | 'ALL'
  }
}

type Params = {
  topic: string
  type?: string
}

export const getStaticProps: GetStaticProps<Props, Params> = async ({ params }) => {
  const type = params?.type?.toUpperCase() as API.LibraryPostType | undefined
  const slug = params?.topic || 'all'

  const client = initApollo({})

  let topic: NonNullable<API.Topic['libraryTopic']> = {
    __typename: 'LibraryTopic',
    id: 'all',
    slug: 'all',
    title: 'All topics',
    color: API.LibraryGuideColor.BLUE_01,
  }

  if (slug !== 'all') {
    const { data } = await client.query<API.Topic, API.TopicVariables>({
      query: TOPIC,
      variables: {
        slug,
      },
    })

    if (!data.libraryTopic)
      return {
        notFound: true,
      }

    topic = data.libraryTopic
  }

  const { data: dataPosts } = await client.query<API.TopicPosts, API.TopicPostsVariables>({
    query: POSTS,
    variables: {
      topicSlug: slug === 'all' ? undefined : slug,
      type,
      perPage: 1000,
    },
  })

  return {
    props: {
      ...topic,
      posts: dataPosts.libraryPosts?.nodes ?? [],
      filters: { type: type || 'ALL' },
    },
  }
}
